/*
  EBG mega meny – kolonner
  Hører til snippets/ebg-megamenu.liquid. Ingen avhengigheter, lastes med defer.

  Samme regel som snippets/ebg-megamenu.liquid: fast 4 kolonner, og det som
  blir til overs havner i sluttraden (5 punkter blir 4 + 1, 6 blir 4 + 2).
  Unntak: 9 og 10 punkter får 5 kolonner (5 + 4 og 5 + 5). Tallet skal ikke
  vokse med skjermen: samme meny skal se lik ut uansett vindusbredde.

  Denne filen finnes fordi taket likevel må kunne senkes: er panelet så smalt
  at kolonnene blir uleselige, teller vi hvor mange som faktisk får plass ved
  minstebredden. Som i den grønne PRODUKTER-menyen er minstebredden en
  nedbremsing, ikke et komfortmål, og står derfor lavt – å kutte en kolonne
  gir som regel en rad til, og en rad koster langt mer enn et produktnavn som
  brekker til to linjer.

  Panelet er skjult til man peker på menyen, så bredden kan ikke måles på det.
  Header-containeren er alltid synlig og nøyaktig like bred (målt: 1470 px
  begge steder på en 1800-skjerm), så den brukes i stedet.

  Kolonnebredden har et eget tak (--ebg-mm-max i CSS-en). Når radene skal være
  fulle, blir antallet lavt – 6 punkter blir 3 + 3 – og da skal kolonnene
  stoppe på en lesbar bredde i stedet for å strekke seg over hele panelet.
  Uten det ble de 474 px rundt 215 px tekst. Plassen som blir til overs legges
  i mellomrommene.
*/
(function () {
  'use strict';

  /* Absolutt nedre grense for kolonnebredden – en nedbremsing, ikke et
     komfortmål. Samme verdi og samme begrunnelse som i PRODUKTER-menyen. */
  var MIN_BREDDE = 140;
  /* Taket. Følger ikke skjermbredden: menyen skal se lik ut på alle skjermer.
     9 og 10 punkter får 5, se regnUt. */
  var TAK = 4;
  /* Samme verdi som --ebg-mm-gap i assets/ebg-megamenu.css. */
  var GAP = 24;
  /* 1025 px = temaets lg-brekk. Under dette er menyen temaets mobilmeny, og
     .ebg-mm__*-klassene ligger passive i markupen. */
  var mq = window.matchMedia('(min-width: 1025px)');

  function panelBredde() {
    var cont = document.querySelector('.header__line-bottom .container');
    if (!cont) return 0;
    var stil = window.getComputedStyle(cont);
    return (
      cont.clientWidth -
      (parseFloat(stil.paddingLeft) || 0) -
      (parseFloat(stil.paddingRight) || 0)
    );
  }

  function regnUt() {
    var grids = document.querySelectorAll('.ebg-mm__grid');
    if (!grids.length) return;

    if (!mq.matches) {
      // Mobilmenyen har ingen kolonner – la Liquid-verdien staa urørt
      grids.forEach(function (grid) {
        grid.style.removeProperty('--ebg-mm-cols');
      });
      return;
    }

    var bredde = panelBredde();
    if (!bredde) return;

    var passer = Math.floor((bredde + GAP) / (MIN_BREDDE + GAP));

    grids.forEach(function (grid) {
      var antall = grid.querySelectorAll('.ebg-mm__col').length;
      if (!antall) return;
      var tak = antall === 9 || antall === 10 ? 5 : TAK;
      grid.style.setProperty('--ebg-mm-cols', Math.max(1, Math.min(tak, passer, antall)));
    });
  }

  function start() {
    regnUt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('resize', regnUt);

  // Temaeditoren laster seksjoner paa nytt
  document.addEventListener('shopify:section:load', start);
})();
